import { useMutation, useQuery } from 'react-query';
import { LoginPopupsService } from '~/api/services/loginPopups';
import { onError } from '~/utils/helpers';

const getLoginPopupsList = (data?) => useQuery(
  `login-popups-list-${JSON.stringify(data)}`,
  () => LoginPopupsService.getLoginPopupsList(),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getChangeDataRequests = (data?) => useQuery(
  `change-data-requests-list-${JSON.stringify(data)}`,
  () => LoginPopupsService.getChangeDataRequests(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getChangeDataRequestsIndexData = (data?) => useQuery(
  'change-data-requests-index-data',
  () => LoginPopupsService.getChangeDataRequestsIndexData(data),
  {
    onError,
    refetchOnMount: true,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

const getChangeDataRequestFields = (id: string) => useQuery(
  'change-data-requests-review-fields',
  () => LoginPopupsService.getChangeDataRequestFields(id),
  {
    onError,
    refetchOnMount: true,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

const getChangeDataCounts = (data) => useQuery(
  'change-data-requests-counts',
  () => LoginPopupsService.getChangeDataCounts(data),
  {
    onError,
    refetchOnMount: true,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

type ResolveRequestPayload = {
  id: string
  acceptedFields: number[]
  rejectedFields: number[]
}

const resolveChangeDataRequest = (onSuccess?) => useMutation(
  ({ id, acceptedFields, rejectedFields }: ResolveRequestPayload) =>
    LoginPopupsService.resolveChangeDataRequest(id, { acceptedFields, rejectedFields }),
  {
    onSuccess,
    onError,
    retry: 1
  }
)

const acceptChangeDataRequestField = (onSuccess?) => useMutation(
  ({ id, fieldId }: { id: string; fieldId: number }) =>
    LoginPopupsService.acceptChangeDataRequestField(id, fieldId),
  {
    onSuccess,
    onError,
    retry: 1
  }
)

const rejectChangeDataRequestField = (onSuccess?) => useMutation(
  ({ id, fieldId }: { id: string; fieldId: number }) =>
    LoginPopupsService.rejectChangeDataRequestField(id, fieldId),
  {
    onSuccess,
    onError,
    retry: 1
  }
)

export const LoginPopupsQuery = {
  getLoginPopupsList,
  getChangeDataRequests,
  getChangeDataRequestsIndexData,
  getChangeDataRequestFields,
  resolveChangeDataRequest,
  acceptChangeDataRequestField,
  rejectChangeDataRequestField,
  getChangeDataCounts
}